/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Change Data Capture (CDC) configuration for the subscription.
 * @export
 * @interface SubscriptionCdc
 */
export interface SubscriptionCdc {
    /**
     * Whether CDC is enabled for this subscription.
     * @type {boolean}
     * @memberof SubscriptionCdc
     */
    enabled: boolean;
    /**
     * Kafka topic used by Debezium to publish changes for this subscription. This is used by the notification engine to read data for this subscription.
     * @type {string}
     * @memberof SubscriptionCdc
     */
    debeziumKafkaTopic: string;
    /**
     * Kafka topic used by the notification engine to publish notifications for this subscription. This topic is then consumed by the notification engine to send notifications to consumers.
     * @type {string}
     * @memberof SubscriptionCdc
     */
    notificationsKafkaTopic: string;
    /**
     * Correlation ID used to correlate messages in the notification engine.
     * @type {string}
     * @memberof SubscriptionCdc
     */
    correlationId: string;
}

/**
 * Check if a given object implements the SubscriptionCdc interface.
 */
export function instanceOfSubscriptionCdc(value: object): value is SubscriptionCdc {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('debeziumKafkaTopic' in value) || value['debeziumKafkaTopic'] === undefined) return false;
    if (!('notificationsKafkaTopic' in value) || value['notificationsKafkaTopic'] === undefined) return false;
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    return true;
}

export function SubscriptionCdcFromJSON(json: any): SubscriptionCdc {
    return SubscriptionCdcFromJSONTyped(json, false);
}

export function SubscriptionCdcFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionCdc {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'debeziumKafkaTopic': json['debeziumKafkaTopic'],
        'notificationsKafkaTopic': json['notificationsKafkaTopic'],
        'correlationId': json['correlationId'],
    };
}

export function SubscriptionCdcToJSON(json: any): SubscriptionCdc {
    return SubscriptionCdcToJSONTyped(json, false);
}

export function SubscriptionCdcToJSONTyped(value?: SubscriptionCdc | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'debeziumKafkaTopic': value['debeziumKafkaTopic'],
        'notificationsKafkaTopic': value['notificationsKafkaTopic'],
        'correlationId': value['correlationId'],
    };
}

